// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M10.1145 21.8111C9.33859 21.1725 8.30183 20.2494 7.26196 19.112C5.2179 16.8762 3 13.637 3 10C3 5.02944 7.02944 1 12 1C16.9706 1 21 5.02944 21 10C21 13.6373 18.7821 16.8765 16.738 19.1123C15.6981 20.2496 14.6614 21.1727 13.8854 21.8112C13.2782 22.3109 12.6472 22.7686 12 23.2136C11.3529 22.7684 10.7214 22.3105 10.1145 21.8111ZM13.4142 10.5L15.5355 8.37868L14.1213 6.96447L12 9.08579L9.87868 6.96447L8.46447 8.37868L10.5858 10.5L8.46447 12.6213L9.87868 14.0355L12 11.9142L14.1213 14.0355L15.5355 12.6213L13.4142 10.5Z"}}]};

const LocationErrorFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'location-error-filled',
    ref,
    icon: element,
  },
));

LocationErrorFilledIcon.displayName = 'LocationErrorFilledIcon';

export default LocationErrorFilledIcon;
